<template>
  <v-dialog v-if="family" v-model="dialog" persistent max-width="1100px" ref="winPresent">
    <v-card>
      <v-card-title>
        <div class="d-flex flex-column card-title">
          <h2 class="bis">{{fa_id===-1? "Création d'" : "Édition d'"}}{{getWinText(true)}}</h2>
        </div>
      </v-card-title>
      <v-card-text grid-list-xl :style="stylecontainer">
        <v-row ref="mycontainer">
          <v-col cols="6">
            <div v-if="ca_id===0" class="matrice-family-name">
              {{getWinLevel()}}
              <span class="bis">{{name}}</span>
            </div>
            <!--  <m-form-combobox
              v-if="ca_id!==0"
              v-model="family"
              :label="'Créer ou associer '+getWinText(true)"
              labelPosition="top"
              :name="$Utils.randomstring('search-family')"
              :store-url="$config.server_url + '/api/1.0/families/combobox/'+level"
              :store-params="{catalog:catalogCombobox, family:0, create:true}"
              item-text="fa_path"
              item-value="fa_id"
            ></m-form-combobox>-->
            <div
              class="withpointer d-flex flex-row mt-2"
              @click="showColorPicker = !showColorPicker"
            >
              <div
                class="color"
                :style="family.fa_color?'background-color:'+family.fa_color+';':'background-color:#ddd;'"
              ></div>
              <div class="ml-2">Couleur</div>
            </div>

            <v-color-picker
              v-if="showColorPicker"
              v-model="family.fa_color"
              :hide-mode-switch="false"
              mode="hexa"
              flat
            ></v-color-picker>
            <v-row v-if="level!==3">
              <v-col cols="6" class="d-flex flex-column">
                <div>{{level===1 ? 'Choisir une image pour la famille': 'Choisir un logo pour la sous-famille (optionnel)'}}</div>
                <div class="container-img mt-3">
                  <div class="img1">
                    <img
                      class="img"
                      v-if="family.fa_image"
                      :src="familyImage.img1.binary ? familyImage.img1.binary : $config.server_url+'/api/1.0/families/image/'+family.fa_id+'/1'+ '?token='+$store.state.token+'&d='+new Date().getTime()"
                      alt
                    />
                    <div
                      v-if="family.fa_image && family.fa_level===1"
                      class="demo-cover-color"
                      :style="`background-color:${family.fa_color};`"
                    ></div>
                  </div>
                  <!-- <v-img
                    v-if="family.fa_image"
                    :src="familyImage.img1.binary ? familyImage.img1.binary : $config.server_url+'/api/1.0/families/image/'+family.fa_id+'/1'+ '?token='+$store.state.token+'&d='+new Date().getTime()"
                    width="150px"
                    height="200px"
                  >
                    <div
                      v-if="family.fa_image && family.fa_level===1"
                      class="demo-cover-color"
                      :style="`background-color:${family.fa_color};`"
                    ></div>
                     <div class="demo-cover-img2" :style="`background-color:#fad831;`"></div> 
                  </v-img>-->
                </div>
                <v-btn
                  @click="editImg('img1')"
                  small
                  depressed
                  class="btn-edit-img mt-3 primary2"
                >Modifier l'image</v-btn>
                <input
                  hidden
                  type="file"
                  ref="inputImgNode"
                  name="imageNode"
                  accept="image/png, image/jpeg"
                  @change="changeImg($event, 'img1')"
                />
                <!-- <v-btn small text class="btn-edit-img btn-delete-img mt-3">Supprimer l'image</v-btn> -->
                <v-checkbox
                  hide-details
                  label="Supprimer l'image"
                  style="margin-top:0;"
                  v-model="deleteImage1"
                ></v-checkbox>
              </v-col>
              <v-col v-if="level===1" cols="6" class="d-flex flex-column container-btn-edit-img">
                <div>Choisir une seconde image</div>
                <div class="container-img mt-3">
                  <div class="img2">
                    <v-img
                      v-if="family.fa_image2"
                      :src="familyImage.img2.binary ? familyImage.img2.binary:$config.server_url+'/api/1.0/families/image/'+family.fa_id+'/2'+ '?token='+$store.state.token+'&d='+new Date().getTime()"
                      width="150px"
                      height="150px"
                    ></v-img>
                    <!-- <div
                      v-if="family.fa_image && family.fa_level===1"
                      class="demo-cover-color"
                      :style="`background-color:#fff;`"
                    ></div>-->
                  </div>
                </div>
                <v-btn
                  @click="editImg('img2')"
                  small
                  depressed
                  class="btn-edit-img mt-3 primary2"
                >Modifier l'image</v-btn>
                <input
                  hidden
                  type="file"
                  ref="inputImgNode2"
                  name="imageNode2"
                  accept="image/png, image/jpeg"
                  @change="changeImg($event, 'img2')"
                />
                <!-- <v-btn small text class="btn-edit-img btn-delete-img mt-3">Supprimer l'image</v-btn> -->
                <v-checkbox
                  hide-details
                  label="Supprimer l'image"
                  style="margin-top:0;"
                  v-model="deleteImage2"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="col-traduction">
            <div class="bis">Nom et traduction {{level!==3?' de la ':' du '}} {{getWinText(false)}}</div>
            <m-form-text
              class="inputUppercase"
              :name="$Utils.randomstring('fa_name_fr')"
              label="Français"
              :label-width="2"
              v-model="family.fa_name_fr"
              :value="family.fa_name_fr"
            ></m-form-text>
            <m-form-text
              :name="$Utils.randomstring('fa_name_en')"
              label="Anglais"
              :label-width="2"
              v-model="family.fa_name_en"
              :value="family.fa_name_en"
            ></m-form-text>
            <m-form-text
              :name="$Utils.randomstring('fa_name_sp')"
              label="Espagnol"
              :label-width="2"
              v-model="family.fa_name_sp"
              :value="family.fa_name_sp"
            ></m-form-text>
            <m-form-text
              :name="$Utils.randomstring('fa_name_pl')"
              label="Polonais"
              :label-width="2"
              v-model="family.fa_name_pl"
              :value="family.fa_name_pl"
            ></m-form-text>
            <div v-if="this.level===1">
              <div class="mt-4 bis">Nom et traduction du grand titre (optionnel)</div>
              <m-form-text
                :name="$Utils.randomstring('fa_grtitre_fr')"
                label="Français"
                :label-width="2"
                v-model="family.fa_grtitre_fr"
                :value="family.fa_grtitre_fr"
              ></m-form-text>
              <m-form-text
                :name="$Utils.randomstring('fa_grtitre_en')"
                label="Anglais"
                :label-width="2"
                v-model="family.fa_grtitre_en"
                :value="family.fa_grtitre_en"
              ></m-form-text>
              <m-form-text
                :name="$Utils.randomstring('fa_grtitre_sp')"
                label="Espagnol"
                :label-width="2"
                v-model="family.fa_grtitre_sp"
                :value="family.fa_grtitre_sp"
              ></m-form-text>
              <m-form-text
                :name="$Utils.randomstring('fa_grtitre_pl')"
                label="Polonais"
                :label-width="2"
                v-model="family.fa_grtitre_pl"
                :value="family.fa_grtitre_pl"
              ></m-form-text>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary2--text" color text @click="cancelWin()">Annuler</v-btn>
        <v-btn
          color="primary2"
          depressed
          @click="saveWin()"
          :disabled="!$store.state.myrights.create_catalogue"
        >Enregistrer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "familywinedit",
  props: { ca_id: Number },
  components: {},
  data() {
    return {
      deleteImage1: false,
      deleteImage2: false,
      family: {},
      showColorPicker: false,
      dialog: false,
      stylecontainer: ``,
      confirmDeleteDialog: false,
      catalogCombobox: null,
      nodeParent: null,
      level: 0,
      name: "",
      fa_id: null,
      responseDetails: {},
      familyImage: {
        img1: { img: null, binary: null },
        img2: { img: null, binary: null }
      },
      familyImageRefs: {
        img1: "inputImgNode",
        img2: "inputImgNode2"
      }
    };
  },
  mounted() {
    window.addEventListener("resize", this.setContainerStyle);
  },
  destroyed() {
    window.removeEventListener("resize", this.setContainerStyle);
  },
  computed: {},
  watch: {},
  methods: {
    setContainerStyle() {
      let me = this;
      function go() {
        if (!me.$refs.mycontainer) return;
        if (me.$refs.mycontainer.clientHeight > window.innerHeight - 300)
          me.stylecontainer = `height: calc(100vh - 253px); overflow:auto;`;
        else me.stylecontainer = "";
      }
      go();
      window.setTimeout(go, 100);
      window.setTimeout(go, 1000);
    },
    async open(fa_id, level, name, ca_id, nodeParent = false) {
      this.deleteImage1 = false;
      this.deleteImage2 = false;
      this.familyImage = {
        img1: { img: null, binary: null },
        img2: { img: null, binary: null }
      };
      this.showColorPicker = false;
      this.fa_id = fa_id;
      console.log("je passe dans open");
      let response = await this.$axios.get(
        this.$config.server_url + "/api/1.0/families/" + fa_id
      );
      this.family = response.data.data;
      if (nodeParent) {
        this.catalogCombobox = 0;
        this.nodeParent = nodeParent;
        this.level = level + 1;
      } else {
        this.level = level;
        this.name = name;
        this.catalogCombobox = ca_id;
      }

      // console.log("this.family", this.family);
      this.dialog = true;
      this.setContainerStyle();
    },
    getWinText(determinant) {
      let text = "";
      if (this.level === 1) text = determinant ? "une famille  " : "famille  ";
      if (this.level === 2)
        text = determinant ? "une sous-famille " : "sous-famille";
      if (this.level === 3) text = determinant ? "un segment " : "segment";
      return text;
    },
    getWinLevel() {
      let family = "";
      if (this.level === 1) family = "FAMILLE ";
      if (this.level === 2) family = "SOUS-FAMILLE ";
      if (this.level === 3) family = "SEGMENT ";
      return family;
    },
    cancelWin() {
      this.familyImage = {
        img1: { img: null, binary: null },
        img2: { img: null, binary: null }
      };
      this.dialog = false;
      if (this.$route.name === "matricefamilyedit") {
        this.$router.push("/matrice");
      } else {
        this.$router.push("/catalogs/edit/" + this.ca_id);
      }
    },
    editImg(img) {
      let inputRef = this.familyImageRefs[img];
      this.$refs[inputRef].click();
    },
    changeImg(e, img) {
      // console.log("change image", e.target.files[0]);
      if (!e.target.files.length) return;
      this.familyImage[img].image = e.target.files[0];
      var reader = new FileReader();
      var me = this;
      reader.onload = (function(theFile) {
        return function(e) {
          me.familyImage[img].binary = e.target.result;
        };
      })(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
      if (img == "img2")
        this.family.fa_image2 = this.familyImage[img].image.name;
      else this.family.fa_image = this.familyImage[img].image.name;
    },
    async saveWin() {
      if (!this.family.fa_name_fr || !this.familyImage.img1) return;
      if ((this.family.fa_path = "* CREER *")) {
        this.family.fa_level = this.level;
        //this.family.fa_path = "/"+this.nodeParent+"/"+ this.family.fa_name_fr+"/";
      }
      if (this.family.fa_color && this.family.fa_color.length > 7) {
        this.family.fa_color = this.family.fa_color.substring(
          0,
          this.family.fa_color.length - 2
        );
      }
      let tabInput = [
        "fa_name_fr",
        "fa_name_sp",
        "fa_name_en",
        "fa_name_pl",
        "fa_grtitre_pl",
        "fa_grtitre_sp",
        "fa_grtitre_en",
        "fa_grtitre_fr"
      ];
      for (let index = 0; index < tabInput.length; index++) {
        const input = tabInput[index];
        this.family[input] = this.family[input].toUpperCase();
      }
      this.family.deleteImage1 = this.deleteImage1;
      this.family.deleteImage2 = this.deleteImage2;
      // création de la famille
      let response = null;
      if (this.fa_id === -1) {
        response = await this.$axios.post(
          this.$config.server_url +
            "/api/1.0/families/" +
            this.ca_id +
            "/" +
            this.nodeParent.id,
          this.family
        );
      } else {
        // maj de la famille + les details de la famille seulement si on est dans la matrice
        response = await this.$axios.put(
          this.$config.server_url +
            "/api/1.0/families/" +
            this.fa_id +
            "/" +
            this.ca_id,
          this.family
        );
      }
      let me = this;
      async function saveImage(file, indexImg) {
        if (!file) return;
        let formData = new FormData();
        formData.append("fa_id", response.data.data.fa_id);
        formData.append("ca_id", me.ca_id);
        formData.append("image", file, file.name);
        await me.$axios.post(
          me.$config.server_url + "/api/1.0/families/image/" + indexImg,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
      }
      // console.log("this.familyImage.img1.image", this.familyImage.img1.image);
      await saveImage(this.familyImage.img1.image, 1);
      await saveImage(this.familyImage.img2.image, 2);
      this.$emit("familyWinEditSaved", response.data.data);
      this.dialog = false;
    }
  }
};
</script>

<style scoped lang="scss">
.card-title {
  text-align: left;
}
.title-designation {
  font-size: 16px;
}
.btn-edit-img {
  width: 100%;
}
.btn-delete-img {
  color: #ff1412;
}
.container-btn-edit-img {
  justify-content: flex-end;
}
.matrice-family-name {
  border-radius: 5px;
  border: solid 1px #cfd8db;
  padding: 2px 10px;
}
#rozenbal .color {
  width: 20px;
  height: 20px;
  border-radius: 2px;
}
#rozenbal .container-img {
  position: relative;
  width: 100%;
  height: 200px;
  border: solid 1px #ebebeb;
}
#rozenbal .container-img .img1 {
  width: 150px;
  height: 200px;
  margin-left: auto;
  margin-right: auto;
}
#rozenbal .container-img .img1 img {
  width: 150px;
  height: 200px;
}

.v-image {
  margin-right: auto;
  margin-left: auto;
}
#rozenbal .col-traduction .m-form-base {
  padding-left: 40px;
}
.demo-cover-color {
  position: absolute;
  top: 0;
  left: 50%;
  width: 75px;
  height: 200px;
  z-index: 1;
}
.demo-cover-img2 {
  position: absolute;
  top: 65px;
  right: 50px;
  width: 70px;
  height: 60px;
}
.m-form-base {
  .m-form-base__container-input {
    input {
      text-transform: uppercase !important;
    }
  }
}
</style>